import React, { useContext } from 'react';
import { string, shape, func } from 'prop-types';
import { params, bool as boolType, string as stringType, useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext, useStoreId } from '@thd-nucleus/experience-context';
const SuperSkuMiddleware = _ref => {
  var _productData$product, _productData$product$;
  let {
    itemId,
    children
  } = _ref;
  const storeId = useStoreId();
  const {
    isServer
  } = useContext(ExperienceContext);
  const {
    data: productData
  } = useDataModel('clientOnlyProduct', {
    variables: {
      itemId,
      storeId
    },
    skip: !itemId,
    ssr: false
  });
  const additionalProps = {};
  const displayConfigurator = !isServer && (productData === null || productData === void 0 ? void 0 : (_productData$product = productData.product) === null || _productData$product === void 0 ? void 0 : (_productData$product$ = _productData$product.identifiers) === null || _productData$product$ === void 0 ? void 0 : _productData$product$.productType) === 'CONFIGURABLE_BLINDS';
  if (!productData || displayConfigurator) {
    return null;
  }
  return children({
    props: additionalProps
  });
};
SuperSkuMiddleware.propTypes = {
  itemId: string.isRequired,
  children: func.isRequired
};
SuperSkuMiddleware.displayName = 'SuperSkuRules';
SuperSkuMiddleware.dataModel = {
  clientOnlyProduct: params({
    itemId: stringType().isRequired()
  }).shape({
    info: shape({
      dotComColorEligible: boolType()
    })
  })
};
export { SuperSkuMiddleware };
//# sourceMappingURL=SuperSkuMiddleware.js.map